import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { rgba } from 'polished';

import {
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_ORANGE,
  COLOR_RED,
  COLOR_GREEN,
} from '../../assets/styles/colors';

export const BiggerTextSC = styled.span`
  color: ${COLOR_BLACK};
  font-size: 18px;
  margin-bottom: 0;
  display: inline-block;
  &.white {
    color: ${COLOR_WHITE};
  }
  &.grey {
    color: ${rgba(COLOR_WHITE, 0.6)};
  }
  &.orange {
    color: ${COLOR_ORANGE};
  }
  &.black-transparent {
    color: ${rgba(COLOR_BLACK, 0.6)};
  }
  &.black-transparent-lighter {
    color: ${rgba(COLOR_BLACK, 0.4)};
  }
  &.bolder {
    font-weight: 600;
  }
  &.bold {
    font-weight: bold;
  }
  &.red {
    color: ${COLOR_RED};
  }
  &.green {
    color: ${COLOR_GREEN};
  }
  &.uppercase {
    text-transform: uppercase;
  }
  &.align-left {
    text-align: left;
  }
`;

const BiggerText = (props) => {
  const { children, className } = props;
  const customClass = classNames({ [className]: className !== '' });

  return <BiggerTextSC className={customClass}>{children}</BiggerTextSC>;
};

BiggerText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

BiggerText.defaultProps = {
  className: '',
};

export default BiggerText;
